import { v4 as uuidv4 } from 'uuid'

export const getOrGenerateTwoFARememberToken = (username: string) => {
  if (!username) throw new Error('username is required')

  const storageKey = `device_uuid_${username}`
  let deviceUUID = localStorage.getItem(storageKey)

  if (!deviceUUID) {
    deviceUUID = uuidv4()
    localStorage.setItem(storageKey, deviceUUID)
  }

  return deviceUUID
}

export const getTwoFARememberToken = (username: string) => {
  if (!username) throw new Error('username is required')

  const storageKey = `device_uuid_${username}`

  return localStorage.getItem(storageKey)
}
